import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    color: '#000429',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  button: {
    width: '100%',
    margin: '0',
  },
  text: {
    fontSize: '16px',
  },
  storeName: {
    fontWeight: 'bold',
  },
}));
